// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-message-wrapper[data-v-20c38dc0],h2[data-v-20c38dc0]{margin-bottom:20px}.error-message-wrapper p[data-v-20c38dc0]{margin-bottom:10px}.error-message-wrapper p[data-v-20c38dc0]:last-child{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
